import { Directionality } from "@angular/cdk/bidi";
import { NgClass, NgStyle } from "@angular/common";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Host, Optional, Renderer2, TemplateRef, ViewChild, ViewContainerRef } from "@angular/core";
import { NzNoAnimationDirective } from "ng-zorro-antd/core/no-animation";
import { NzSafeAny } from "ng-zorro-antd/core/types";
import { NzDropdownMenuComponent } from "ng-zorro-antd/dropdown";
import { UiMenuService } from "@webapp/ui/menu/services/menu.service";
import { UiIsMenuInsideDropDownToken } from "@webapp/ui/menu/utils/menu.utils";

@Component({
  selector: `ui-dropdown-menu`,
  exportAs: `uiDropdownMenu`,
  providers: [
    UiMenuService,
    /** menu is inside dropdown-menu component **/
    {
      provide: UiIsMenuInsideDropDownToken,
      useValue: true,
    },
  ],
  templateUrl: "./dropdown-menu.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NgClass, NgStyle, NzNoAnimationDirective],
})
export class UiDropdownMenuComponent extends NzDropdownMenuComponent {
  @ViewChild(TemplateRef, { static: true }) public templateRef!: TemplateRef<NzSafeAny>;

  constructor(
    cdr: ChangeDetectorRef,
    elementRef: ElementRef,
    renderer: Renderer2,
    public viewContainerRef: ViewContainerRef,
    public uiMenuService: UiMenuService,
    @Optional() directionality: Directionality,
    @Host() @Optional() noAnimation?: NzNoAnimationDirective
  ) {
    super(cdr, elementRef, renderer, viewContainerRef, uiMenuService, directionality, noAnimation);
  }
}
